import { getQaSelector } from '../../../utils/common'

import { QA_NAME_SUB_MENU_CONTEXT } from './SubMenuWrapper.constants'

import * as styles from './SubMenuWrapper.module.css'

function SubMenuWrapper({
  children,
  className = styles.SubMenuWrapper,
  qaName,
}) {
  const submenuProps = getQaSelector({
    context: QA_NAME_SUB_MENU_CONTEXT,
    value: qaName,
  })

  return (
    <div {...submenuProps} className={className}>
      {children}
    </div>
  )
}

export default SubMenuWrapper
